module.exports = __webpack_public_path__ + "img/ai4.3ba339a2.png";